import React from "react";
import AppBar from "../../components/DefaultAppBar";
import TicketForm from "./TicketForm";
import Box from "@mui/material/Box";
import CurrentEstateToolbar from "@/components/CurrentEstateToolbar";

export const route = "/tickets/new";

const TicketFormContainer = () => {
  return (
    <Box sx={{ position: "relative", pt: 2, pb: 7 }}>
      <AppBar>
        <CurrentEstateToolbar />
      </AppBar>
      <TicketForm />
    </Box>
  );
};

TicketFormContainer.route = route;

export default TicketFormContainer;
